// extracted by mini-css-extract-plugin
module.exports = {"lighbox_list":"Detail_lighbox_list__2rjCb","lightbox_image":"Detail_lightbox_image__TGZpH","selected":"Detail_selected__TKYqw","marqueeItem":"Detail_marqueeItem__kBz_a"};